import React from 'react';
export const footerView = (props) => {
  return (
    <div className='footer__wrapper'>
      <div className='row'>
    <div className='col-md-8 copyright-left px-5'>PRIVACY NOTICE | COOKIE NOTICE | TERMS OF USE | SITE MAP</div>
    <div className='col-md-3 copyright-right'>© {new Date().getFullYear()} Xebia All rights reserved.</div>
    </div>
    </div>
  );
};

export const PrintOptions = (payload) => {
  const { options, value } = payload;

  return (
    <>
      <option value='' selected={value === ''}>
        Select
      </option>
      {options.map((item) => {
        return (
          <option key={item.id} value={item.id} selected={value === item.id}>
            {item.displayLabel}
          </option>
        );
      })}
    </>
  );
};
